module.exports = __webpack_public_path__ + "static/media/Pc4-4.09224456.jpeg";